import { qs, qsa } from "@fluorescent/dom";
import {
  ImageReveal,
  FadeUpReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  details: ".featured-product__details .animation-fade-up-reveal",
  featuredImage:
    ".featured-product__media-container .product__media-item:not(.hidden) .image",
};

export default node => {
  let observer = null;
  const revealsRight = [];
  let imageReveal = null;

  const details = qsa(selectors.details, node);
  const featuredImage = qs(selectors.featuredImage, node);

  if (shouldAnimate(node)) {
    details.forEach(item => {
      revealsRight.push(new FadeUpReveal(item));
    });

    if (featuredImage) {
      imageReveal = new ImageReveal(featuredImage);
    }

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    revealsRight.forEach((reveal, i) => {
      reveal.play(window.theme.animation.delayExtraShort * i);
    });

    if (imageReveal) {
      imageReveal.play(window.theme.animation.delayExtraShort);
    }
  }

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
